import { EAppModule } from "dto/EAppModule";
import { create } from "zustand";

const usePrivilegesStore = create((set) => ({
  active: "free",
  privileges: [],
  loaded: false,
  init: (p: []) => {
    set(() => ({ privileges: p, loaded: true }));
    console.log("Privileges initialized", p);
  },

  switchToFree: () => {
    set(() => ({
      active: "free",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
      ],
    }));
  },

  swtichToStandard: () => {
    set(() => ({
      active: "standard",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
        EAppModule.Cases,

        EAppModule.Drive,
        EAppModule.Word,
        EAppModule.Notes,
      ],
    }));
  },

  swtichToPremium: () => {
    set(() => ({
      active: "premium",
      privileges: [
        EAppModule.Incoming,
        EAppModule.Outgoing,
        EAppModule.AddressBook,
        EAppModule.Desk,
        EAppModule.Cases,
        EAppModule.Drive,
        EAppModule.Word,
        EAppModule.Notes,

        EAppModule.EncryptedParcels,
        EAppModule.WordExt,
        EAppModule.Tasks,
        EAppModule.Workspace,
        EAppModule.CourtPortal,
      ],
    }));
  },

  toggleModule: (module: EAppModule) => {
    set((state) => {
      let currentPrivileges: string[] = state.privileges;

      if (currentPrivileges.find((x) => x === module)) {
        currentPrivileges = currentPrivileges.filter((x) => x !== module);
      } else {
        currentPrivileges = [...currentPrivileges, module];
      }

      return {
        privileges: currentPrivileges,
      };
    });
  },
}));

export default usePrivilegesStore;
